import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(_ => _.LoginPageModule) },
  { path: 'lesson-plans', loadChildren: () => import('./pages/lesson-plans/lesson-plans.module').then(_ => _.LessonPlansPageModule) },
  { path: 'pages', children: [
      { path: '**', loadChildren: () => import('./pages/pages/pages.module').then(_ => _.PagesPageModule) }
  ]},
  { path: 'blog', loadChildren: () => import('./pages/teacher-notes/teacher-notes.module').then(_ => _.TeacherNotesPageModule) },
  { path: 'blog/:article', loadChildren: () => import('./pages/blog/article/article.module').then(_ => _.ArticlePageModule) },
  { path: 'bowling/:course', loadChildren: () => import('./pages/bowling/bowling.module').then(_ => _.BowlingPageModule) },
  { path: 'bowling/:course/:lesson', loadChildren: () => import('./pages/bowling/bowling.module').then(_ => _.BowlingPageModule) },
  { path: 'training', loadChildren: () => import('./pages/trainings/trainings.module').then(_ => _.TrainingPageModule) },
  { path: 'landing', loadChildren: () => import('./pages/landing/landing.module').then(_ => _.LandingPageModule) },
  { path: 'lesson/:course/:lesson', loadChildren: () => import('./pages/lesson/lesson.module').then(_ => _.LessonPageModule) },
  { path: 'lesson/:course/:lesson/:source_page', loadChildren: () => import('./pages/lesson/lesson.module').then(_ => _.LessonPageModule) },
  { path: 'parent-education', loadChildren: () => import('./pages/parent-education/parent-education.module').then(_ => _.ParentEducationPageModule) },
  { path: 'teaching-tools', loadChildren: () => import('./pages/teaching-tools/teaching-tools.module').then(_ => _.TeachingToolsPageModule) },
  { path: 'video-library', loadChildren: () => import('./pages/video-library/video-library.module').then(_ => _.VideoLibraryPageModule) },
  { path: 'teacher-notes', redirectTo: 'blog' },

  { path: '**', redirectTo: 'lesson-plans'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
